<template>
  <div id="KenshinRequest">
    <section>
      <div id="container-center">
        <h1 class="title has-text-centered printTarget">{{title}}</h1>
        <div>
          <b-steps v-model="activeStep" :animated="true" :rounded="true" :has-navigation="false" label-position="bottom">
            <b-step-item step="1" label="利用規約" icon="comment-alert-outline" v-if="needAgree">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面</b-button>
                  <b-button class="is-primary" style="float:right" icon-right="chevron-double-right" :disabled="!isChecked" @click.prevent="Forward">次へ</b-button>
                  <span>以下の利用規約を同意のうえ、申込みを行ってください。</span>
                </div>
                <div class="card-content margin-top">
                  <span style="font-size:20px;">利用規約</span>
                  <table>
                    <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement"/></td></tr>
                    <tr>
                        <td>
                          <div style="text-align: center;">
                            「<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer">レンタルの一般条件</a>」は<a :href="getUrlRentalCondition()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。 「<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer">プライバシー規則</a>」は<a :href="getUrlPrivacyPolicy()" target="_blank" rel="noopener noreferrer" style="font-weight: bold;color:yellowgreen">こちら</a>を参照してください。
                          </div>
                        </td>
                    </tr>
                    <tr><td><div style="text-align: center;"></div></td></tr>
                    <tr><td><div style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isChecked" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td></tr>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="2" label="検診情報" icon="clipboard-text">
              <div id="item-contens">
                <div class="request-title">
                    <b-button v-if="needAgree" class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                    <b-button v-else class="is-primary" style="float:left;" icon-left="home" @click.prevent="goHome">ホーム画面 </b-button>
                    <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" :disabled="!isHospitalAgree" @click.prevent="Forward">次へ</b-button>
                    <span>検診の情報を入力してください。</span>
                </div>
                <div class="card-content margin-top">
                  <table>
                    <tr v-if="isProxyApplication">
                      <th>依頼元<span class="require"/></th>
                      <td>
                        <template>
                          <input type="text" style="width:730px;" v-model="requester" disabled class="2" name="依頼元名" validate="required"/>
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="surrogateModalActive=true">依頼元選択</b-button>
                        </template>
                      </td>
                    </tr>
                    <tr>
                      <th>発注元企業名<span class="require" v-if="isDealer || !isAccommodations || isProxyApplication"/></th>
                      <td>
                        <template v-if="isDealer">
                          <input type="text" style="width:730px;" v-model="reqParams.orderCompanyName" disabled class="2" name="発注元企業名" validate="required"/>
                          <b-button style="margin-left:10px; width:150px; height:27px;" @click="organizationModalActive=true">施設選択</b-button>
                        </template>
                        <template v-else-if="isAccommodations">{{reqParams.orderCompanyName}}</template>
                        <template v-else><input type="text" v-model="reqParams.orderCompanyName" class="2" name="発注元企業名" validate="required" maxlength="256"></template>
                      </td>
                    </tr>
                    <tr v-if="isHonsha || isAdmin || isSalesOffice"><th>コメント</th><td>{{reqParams.note}}</td></tr>
                    <tr><th>希望出荷週<span class="require"/></th><td><input type="date" v-model="reqParams.desiredShippingWeek" class="2" name="希望出荷週" validate="required|date|notPastDay" :min="yyyy_hyp_MM_hyp_dd(miniDate)" :max="yyyy_hyp_MM_hyp_dd(maxDate)" style="width:150px;"/></td></tr>
                    <tr><th>検査種類<span class="require"/></th>
                      <td>
                        <select v-model="reqParams.inspectionKind" :disabled="((!isDealer && !belongsId) || (isDealer && !reqParams.institutionId)) || inspectionKindList.length <= 1" class="2" name="検査種類" validate="required">
                          <option v-for="kind in inspectionKindList" :value="kind.value" :key="kind.value">{{ kind.label1 }}</option>
                        </select>
                      </td>
                    </tr>
                    <tr v-if="((!isDealer && belongsId) || (isDealer && reqParams.institutionId)) && inspectionKindList.length <= 1">
                      <th></th><td>現在、ご契約済の検査種類はございません。営業担当にお問い合わせください。</td>
                    </tr>
                    <tr v-if="isDealer || isHospital">
                      <th>判定有無<span class="require"/></th><td><div class="block"><b-radio class="td_radio" v-model="reqParams.isJudgment" :native-value="true">する</b-radio><b-radio class="td_radio" v-model="reqParams.isJudgment" :native-value="false">しない</b-radio></div></td>
                    </tr>
                    <tr>
                      <th>備考</th>
                      <td>
                        <textarea v-model="reqParams.biko" maxlength="256" style="resize:vertical;max-width:100%;"></textarea>
                        <br/><span style="font-size: 14px;">※大変申し訳ございませんが、着日指定のコメントを記載いただいても、対応できかねますので、予めご了承ください。</span>
                      </td>
                    </tr>
                    <tr><th class="deliverySlip_label">納品書</th>
                      <td>
                        <div>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="true">必要</b-radio>
                          <b-radio class="td_radio deliverySlip_radio" name="deliverySlip" v-model="reqParams.deliverySlip" :native-value="false">不要</b-radio>
                        </div>
                      </td>
                    </tr>
                    <tr><th>デモ</th><td><b-checkbox class="cstmCheckBox" v-model="reqParams.demo" @input="setInspectionKindList">デモ(トライアル)</b-checkbox></td></tr>
                    <template v-if="isDealer">
                      <tr/>
                      <tr>
                        <th/><td><b-checkbox class="cstmCheckBox" v-model="isHospitalAgree">申請者が企業検診の申込みを行うことについて、該当企業の同意を取得しています。</b-checkbox></td>
                      </tr>
                    </template>
                  </table>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="3" label="配送先情報" icon="account-multiple">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>配送先の情報を入力してください。</span>
                  <b-button class="is-primary" style="float:right;" icon-right="chevron-double-right" @click.prevent="Forward">次へ</b-button>
                </div>
                <template v-for="(item, index) in reqParams.shippingInfoList">
                  <div class="card-content margin-top" :key="index">
                    <span style="font-size: 20px">配送先情報{{index + 1}}</span>
                    <b-button v-if="index>0" style="float:right; width:27px; height:27px; border:none;" icon-left="close-box-outline" @click="deleteItem(index)"></b-button>
                    <table>
                      <tr><th>事業所名<span class="require" /></th><td><input type="text" v-model="item.enterpriseName" maxlength="256" class="3" :name="(index+1)+'番目の事業所名'" validate="required"/></td></tr>
                      <tr v-bind:key="renderKey"><th>装置配送先<span class="require" /></th>
                        <td>
                          <b-field>
                            <span class="zip-mark">〒</span>
                            <input type="text"
                              style="width: 270px; margin-left: 5px; margin-right: 5px; margin-top: 10px;"
                                :placeholder="postcodePlaceholder"
                                v-model="item.deviceDeliveryZip"
                                maxlength="7"
                                class="3"
                                :class="{'border-red': item.invalidShippingPostcode}"
                                :name="(index+1)+'番目の装置配送先の郵便番号'"
                                validate="required|numeric"

                            />
                            <b-button class="passButton" v-on:click="patientAddressSearch(item.deviceDeliveryZip,index,'item')">郵便番号検索</b-button>
                          </b-field>
                          <div v-if="item.invalidShippingPostcode" class="text-red invalid-postcode">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th></th><td>住所:<input type="text" style="margin-left:5px;width:857px;" v-model="item.deviceDeliveryAddress" maxlength="256" class="3" :name="(index+1)+'番目の装置配送先の住所'" validate="required"/></td></tr>
                      <tr>
                        <th></th>
                        <td>
                          連絡先(電話番号):
                          <input
                            type="text"
                            style="margin-left: 5px; width: 768px;"
                            :placeholder="phonePlaceholder"
                            v-model="item.phoneNumber"
                            maxlength="11"
                            class="3"
                            :class="{'border-red': item.invalidShippingPhoneNumber}"
                            :name="(index+1)+'番目の装置配送先の連絡先(電話番号)'"
                            validate="required|numeric"
                          />
                          <div v-if="item.invalidShippingPhoneNumber" class="text-red invalid-phone-number">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th></th><td>宛名:<input type="text"  style="margin-left:5px;width:857px;" v-model="item.deviceDeliveryName" class="3" maxlength="100" :name="(index+1)+'番目の装置配送先の宛名'" validate="required"/></td></tr>
                      <tr v-if="!isAccommodations"><th>診断結果</th><td><b-checkbox class="cstmCheckBox" :id="'checked' + index" style="width:26px;" @input="changeDisabled(index)" v-model="item.resultDelivery">装置配送先と異なる住所に送付する。</b-checkbox></td></tr>
                    </table>
                    <table v-if="!isAccommodations" :id="'appedTable' + index" style="display:none;">
                      <tr v-bind:key="renderKey">
                        <th>診断結果送付先<span class="require" /></th>
                        <td>
                          <b-field>
                            <span class="zip-mark">〒</span>
                            <input
                              type="text"
                              style="width: 270px; margin-left: 5px; margin-right: 5px; margin-top: 10px;"
                              :placeholder="postcodePlaceholder"
                              v-model="item.resultDeliveryZip"
                              maxlength="7"
                              :class="['診断結果送付先'+index, {'border-red': item.invalidDeliveryPostcode}]"
                              :name="(index+1)+'番目の診断結果送付先の郵便番号'"
                              validate="required|numeric"
                            />
                            <b-button class="passButton" v-on:click="patientAddressSearch(item.resultDeliveryZip,index,'result')">郵便番号検索</b-button>
                          </b-field>
                          <div v-if="item.invalidDeliveryPostcode" class="text-red invalid-postcode">{{ invalidNumberMessage }}</div>
                        </td>
                      </tr>
                      <tr><th></th><td>住所:<input type="text" style="margin-left:5px;width:857px;" v-model="item.resultDeliveryAddress" maxlength="256" :class="'診断結果送付先'+index" :name="(index+1)+'番目の診断結果送付先の住所'" validate="required"/></td></tr>
                      <tr><th></th><td>宛名:<input type="text" style="margin-left:5px;width:857px;" v-model="item.resultDeliveryName" maxlength="100" :class="'診断結果送付先'+index" :name="(index+1)+'番目の診断結果送付先の宛名'" validate="required"/></td></tr>
                    </table>
                    <table>
                      <tr>
                        <th>被験者リスト</th>
                        <td>
                          <div v-if="!isAccommodations">
                            <input type="button" class="button patientListButton" style="border-color: rgb(118, 118, 118); color: black;padding-top:2px;" value="行追加" @click="addMember(index)">
                            <span name="mouseoverArea" style="cursor:pointer;" @mouseover="changeCursor">
                            <b-upload id="bUpload" style="margin-left:5px;" v-model="tsvfile" v-on:input="tsvLoad(index)">
                              <a class="button patientListButton" style="padding-top:5px;border-color:rgb(118,118,118); color:black;">TSV取り込み</a>
                            </b-upload>
                            </span>
                            <input style="border-color: rgb(118, 118, 118); color: black; margin-left:5px;padding-top:2px;" class="button patientListButton" type="button" value="全てクリア" @click="clearMember(index)"/>
                          </div>
                        </td>
                      </tr>
                    </table>
                    <table v-if="item.subjectList.length > 0">
                      <tr>
                        <th class="th_brank" />
                        <th class="th_no">No.</th>
                        <th class="th_name">姓<span class="require" /></th>
                        <th class="th_name">名<span class="require" /></th>
                        <th class="th_name">姓（カナ）<span class="require" /></th>
                        <th class="th_name">名（カナ）<span class="require" /></th>
                        <th class="th_birth">生年月日</th>
                        <th class="th_gender">性別</th>
                        <th class="th_id">社員番号</th>
                        <th class="th_clear"></th>
                      </tr>
                      <template v-for="(member,rowNum) in item.subjectList">
                        <tr :key=rowNum>
                          <td />
                          <td>{{('000' + (rowNum+1)).slice(-3)}}</td>
                          <td><input type="text" v-model="member.familyName" maxlength="50" class="3 NameField" :name="'配送先情報'+(index + 1)+'の No.'+('000' + (rowNum+1)).slice(-3)+'患者名(姓)'" validate="required|patientName"/></td>
                          <td><input type="text" v-model="member.firstName" maxlength="50" class="3 NameField" :name="'配送先情報'+(index + 1)+'の No.'+('000' + (rowNum+1)).slice(-3)+'患者名(名)'" validate="required|patientName"/></td>
                          <td><input type="text" v-model="member.familyNameKana" maxlength="50" class="3 NameField" :name="'配送先情報'+(index + 1)+'の No.'+('000' + (rowNum+1)).slice(-3)+'患者名カナ(姓)'" validate="required|patientNameKana"/></td>
                          <td><input type="text" v-model="member.firstNameKana" maxlength="50" class="3 NameField" :name="'配送先情報'+(index + 1)+'の No.'+('000' + (rowNum+1)).slice(-3)+'患者名カナ(名)'" validate="required|patientNameKana"/></td>
                          <td><input type="date" v-model="member.birthday" class="3" :name="'配送先情報'+(index + 1)+'の No.'+('000' + (rowNum+1)).slice(-3)+'患者の生年月日'" validate="date|birthDay" :max="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
                          <td style="width:100px;">
                            <div class="block">
                              <b-radio class="td_radio width30" native-value="-" v-model="member.gender">-</b-radio>
                              <b-radio class="td_radio width30" native-value="男" v-model="member.gender">男</b-radio>
                              <b-radio class="td_radio width30" native-value="女" v-model="member.gender">女</b-radio>
                            </div>
                          </td>
                          <td><input class="td_txt" type="text" v-model="member.employeeNumber" maxlength="100"/></td>
                          <td><b-button v-if="!isAccommodations && rowNum>0" class="clearBtn" icon-left="eraser" @click="deleteMember(index, rowNum)" ></b-button>
                          </td>
                        </tr>
                      </template>
                    </table>
                  </div>
                </template>
                <div v-if="!isAccommodations" class="margin-top">
                  <b-button style="width:100%; background:#6191eb; color:black" @click="addAddress">配送先を追加する</b-button>
                </div>
              </div>
            </b-step-item>
            <b-step-item step="4" label="申込み" icon="cloud-upload">
              <div id="item-contens">
                <div class="request-title">
                  <b-button class="is-primary" style="float:left;" icon-left="chevron-double-left" @click.prevent="Backward">前へ</b-button>
                  <span>以下の申込み内容を確認のうえ、下部の「申込みを完了する」ボタンを押下してください。</span>
                </div>
                <!-- 検診申込み詳細 -->
                <kenshinRequestDetail v-bind:data="reqParams" v-bind:isAccommodations="isAccommodations"/>
                <b-button class="is-primary" style="margin-top:5px;width:250px;" @click="requestKenshin">申込みを完了する</b-button>
              </div>
            </b-step-item>
            <b-step-item step="5" label="完了" icon="check" :type="{'is-success': true}" >
              <section class="unPrintTarget">
                <div class="request-title"><span v-if="!isAccommodations">企業検診の申込みを受け付けました。</span><span v-else>スクリーニング検査の申込みを受け付けました。</span></div>
                <div class="margin-top">
                  <b-button class="backbutton is-primary" @click="back">戻る</b-button>
                  <b-button class="printbutton is-primary" icon-left="printer" @click="print">印刷</b-button>
                </div>
              </section>
              <section class="printTarget printMargin">
                <div id="item-contens">
                  <div class="card-content margin-top">
                    <table>
                      <tr><th>受付日時</th><td>{{requestDate}}</td></tr>
                      <tr><th>受付番号</th><td>{{receiptNumber}}</td></tr>
                    </table>
                  </div>
                </div>
                <kenshinRequestDetail v-bind:data="reqParams" v-bind:isAccommodations="isAccommodations"/>
              </section>
            </b-step-item>
          </b-steps>
        </div>
      </div>
    </section>
    <b-modal :active.sync="organizationModalActive" has-modal-card>
      <facilitySelectModal v-if="isDealer" :searchId="userId" @select="setOrganization"></facilitySelectModal>
    </b-modal>
    <b-modal :active.sync="surrogateModalActive" has-modal-card>
      <organizationSelectModal :canSelect="true" :selectRole="[role.role_hospital, role.role_corporation, role.role_dealer, role.role_accommodations]" :selectStatus="extUserStatus.registed" title="依頼元選択" labelForOrg="依頼元名" @select="setSurrogate"></organizationSelectModal>
    </b-modal>
  </div>
</template>
<script>
import {
  role,
  consentStatement,
  choicesType,
  extUserStatus,
  invalidNumberMessage,
  postcodePlaceholder,
  phonePlaceholder
} from "@/components/mock/base/const.js";
import kenshinRequest from "@/components/mock/common/KenshinRequestDetail";
import FacilitySelectModal from "@/components/mock/philips/common/FacilitySelectModal";
import OrganizationSelectModal from "@/components/mock/philips/common/OrganizationSelectModal";

const columnDef =  {'name': 0, 'namekana': 1, 'birthday': 2, 'gender': 3, 'employeeNumber': 4}
const columnDef2 =  {'familyName': 0, 'firstName': 1, 'familyNameKana': 2, 'firstNameKana': 3, 'birthday': 4, 'gender': 5, 'employeeNumber': 6}
export default {
  name: "KenshinRequest",
  methods: {
    changeCursor: function() {
      var cursor = document.getElementById('bUpload')
      cursor.style.display = 'none';
      cursor.style.cursor = 'pointer';
    },
    Backward: function() {
      this.activeStep -= 1;
    },
    Forward: function(event) {
      // バリデーションチェック
      var stepItems = document.getElementsByClassName("step-item")
      var target
      for(var item of stepItems){
        if(item.getAttribute("style") != "display: none;"){
          target = item
        }
      }
      var activeStep = target ? target.getAttribute("step") : ""
      if(activeStep){
        var elements = document.getElementsByClassName(activeStep)
        var result = this.selfMadeValidation(elements)
        if(activeStep==3){
          for(var i=0; i < this.reqParams.shippingInfoList.length; i++){
            for(var j=0; j < this.reqParams.shippingInfoList[i].subjectList.length; j++){
              this.$set(this.reqParams.shippingInfoList[i].subjectList[j],"name",this.reqParams.shippingInfoList[i].subjectList[j].familyName+" "+this.reqParams.shippingInfoList[i].subjectList[j].firstName)
              this.$set(this.reqParams.shippingInfoList[i].subjectList[j],"namekana",this.reqParams.shippingInfoList[i].subjectList[j].familyNameKana+" "+this.reqParams.shippingInfoList[i].subjectList[j].firstNameKana)
            }
            if(!this.reqParams.shippingInfoList[i].resultDelivery) continue
            var resultDeliverElements = document.getElementsByClassName("診断結果送付先"+i)
            var DeliverElementsResult = this.selfMadeValidation(resultDeliverElements)
            result.msg = result.msg + DeliverElementsResult.msg
          }
        }
        if(result.msg){
          this.showErrorMessage(result.msg)
        }else{
          this.activeStep += 1;
        }
      }
    },
    tsvLoad: async function(index){
      var appVue = this.$root.$children[0]
      let _this = this
      let genderMap = {
        0:"-",
        1:"男",
        2:"女",
      }
      this.reqParams.shippingInfoList[index].subjectList = []
      // ロード中か判定
      if (!appVue.$data.isLoading) {
        appVue.loadingStart()
      }
      
      try{
        // FileReader オブジェクトを作成
        let reader = new FileReader();
        var encoding = await this.getEncoding(this.tsvfile)
        reader.readAsText(this.tsvfile, encoding);
        reader.onload = function() {
          
          var recordArray =  reader.result.split('\n');
          for (let i = 0; i < recordArray.length; i++){
            let columns = recordArray[i].split('\t');
            if(i != 0){
              if(columns.length==1 && (columns[0]=="" || columns[0]=="\r")){
                // 改行のみの場合、スキップ
                continue
              }
              if(columns.length != Object.keys(columnDef).length && columns.length != Object.keys(columnDef2).length){
                // 項目数エラー
                console.log("項目数エラー")
                if(_this.reqParams.shippingInfoList[index].subjectList.length==0){
                  _this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}]
                }
                _this.tsvfile = []
                appVue.loadingEnd()
                _this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
                return
              }
              if(columns.length == Object.keys(columnDef).length){
                if(columns[columnDef.name].length > 100 || columns[columnDef.namekana].length > 100 ||
                columns[columnDef.employeeNumber].replace("\r","").length > 100){
                  // 項目の形式、桁数エラー
                  console.log("項目内容エラー")
                  if(_this.reqParams.shippingInfoList[index].subjectList.length==0){
                    _this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}]
                  }
                  _this.tsvfile = []
                  appVue.loadingEnd()
                  _this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
                  return
                }
                
                var name = columns[columnDef.name]
                var familyName = name
                var firstName = ""
                var nameHalfSpaceIndex = name.indexOf(" ")
                var nameFullSpaceIndex = name.indexOf("　")
                if(nameHalfSpaceIndex != -1 && nameFullSpaceIndex != -1){
                  // 半角スペース・全角スペース両方あり
                  var nameSliceindex = nameHalfSpaceIndex < nameFullSpaceIndex ? nameHalfSpaceIndex : nameFullSpaceIndex
                  familyName = name.slice(0,nameSliceindex)
                  firstName = name.slice(nameSliceindex+1,name.length)
                }else if(nameHalfSpaceIndex != -1){
                  // 半角スペースあり
                  familyName = name.slice(0,nameHalfSpaceIndex)
                  firstName = name.slice(nameHalfSpaceIndex+1,name.length)
                }else if(nameFullSpaceIndex != -1){
                  // 全角スペースあり
                  familyName = name.slice(0,nameFullSpaceIndex)
                  firstName = name.slice(nameFullSpaceIndex+1,name.length)
                }

                var nameKana = columns[columnDef.namekana]
                var familyNameKana = nameKana
                var firstNameKana = ""
                var kanaHalfSpaceIndex = nameKana.indexOf(" ")
                var kanaFullSpaceIndex = nameKana.indexOf("　")
                if(kanaHalfSpaceIndex != -1 && kanaFullSpaceIndex != -1){
                  // 半角スペース・全角スペース両方あり
                  var nameSliceindex = kanaHalfSpaceIndex < kanaFullSpaceIndex ? kanaHalfSpaceIndex : kanaFullSpaceIndex
                  familyNameKana = nameKana.slice(0,nameSliceindex)
                  firstNameKana = nameKana.slice(nameSliceindex+1,nameKana.length)
                }else if(kanaHalfSpaceIndex != -1){
                  // 半角スペースあり
                  familyNameKana = nameKana.slice(0,kanaHalfSpaceIndex)
                  firstNameKana = nameKana.slice(kanaHalfSpaceIndex+1,nameKana.length)
                }else if(kanaFullSpaceIndex != -1){
                  // 全角スペースあり
                  familyNameKana = nameKana.slice(0,kanaFullSpaceIndex)
                  firstNameKana = nameKana.slice(kanaFullSpaceIndex+1,nameKana.length)
                }

                let item = {
                  familyName : familyName,
                  firstName : firstName,
                  familyNameKana : familyNameKana,
                  firstNameKana : firstNameKana,
                  birthday: _this.convertDateFormat(columns[columnDef.birthday]),
                  gender: genderMap[columns[columnDef.gender]] ? genderMap[columns[columnDef.gender]] : "-",
                  employeeNumber: columns[columnDef.employeeNumber].replace("\r","")
                }
                _this.reqParams.shippingInfoList[index].subjectList.push(item);
                _this.tsvfile = []
              }else if (columns.length == Object.keys(columnDef2).length){
                if(columns[columnDef2.familyName].length > 50 || columns[columnDef2.firstName].length > 50 ||
                columns[columnDef2.familyNameKana].length > 50 || columns[columnDef2.firstNameKana].length > 50 ||
                columns[columnDef2.employeeNumber].replace("\r","").length > 100){
                // 項目の形式、桁数エラー
                console.log("項目内容エラー")
                if(_this.reqParams.shippingInfoList[index].subjectList.length==0){
                  _this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}]
                }
                _this.tsvfile = []
                appVue.loadingEnd()
                _this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
                return
              }
              let item = {
                familyName : columns[columnDef2.familyName],
                firstName : columns[columnDef2.firstName],
                familyNameKana : columns[columnDef2.familyNameKana],
                firstNameKana : columns[columnDef2.firstNameKana],
                birthday: _this.convertDateFormat(columns[columnDef2.birthday]),
                gender: genderMap[columns[columnDef2.gender]] ? genderMap[columns[columnDef2.gender]] : "-",
                employeeNumber: columns[columnDef2.employeeNumber].replace("\r","")
              }
              _this.reqParams.shippingInfoList[index].subjectList.push(item);
              _this.tsvfile = []
              }
            }
          }
          if(_this.reqParams.shippingInfoList[index].subjectList.length==0){
            _this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}]
          }
          _this.tsvfile = []
          appVue.loadingEnd()
        };

        reader.onerror = function() {
          console.log("読込エラー")
          this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}]
          this.tsvfile = []
          appVue.loadingEnd()
          this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
        };
      }catch(err){
        console.log(err)
        this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}]
        this.tsvfile = []
        appVue.loadingEnd()
        this.showErrorMessage("TSV読み込み中にエラーが発生しました。\nTSVファイルの内容が正しいか確認して、再度読み込み直してください。")
        return
      }
    },
    convertDateFormat: function(val) {
      var list = val.split("/")
      var y = list[0];
      var m = list[1] - 1;
      var d = list[2];
      var date = new Date(y, m, d);
      if (date.getFullYear() != y || date.getMonth() != m || date.getDate() != d) {
        return ""
      }
      return this.yyyy_hyp_MM_hyp_dd(date)
    },
    requestKenshin: function() {
      var messsage = !this.isAccommodations ? "企業検診" : "スクリーニング検査"
      messsage =　messsage + "を申込みます。<br/>申込み内容に間違いがないことを確認して「OK」ボタンを押してください。<br/><br/><span style=\"font-size: 14px;\">※申込み後のキャンセルは申請一覧の受付番号の右端のメールボタンから問い合わせをお願いします。検査機器が出荷された後のキャンセルは不可となり、請求が発生しますのでご注意ください</span>";
      this.$dialog.confirm({
        title: "申込み確認",
        message: messsage,
        cancelText: "修正する",
        onConfirm: async() => {
          this.compleateFlg = false
          var excuteApi = this.setKenshinApplicationPOST;
          var successCallBack = this.setKenshinApplicationPOSTSuccess;
          var errorCallBack = this.setKenshinApplicationPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
          if(this.compleateFlg){
            this.jumpToTop();
            this.activeStep += 1;
          }
        }
      });
    },
    setKenshinApplicationPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.reqParams));
      obj.desiredShippingWeek = obj.desiredShippingWeek.replace(/-/g, "/")
      obj.shippingInfoList.forEach(ship => {
        ship.subjectList.forEach(patient => {
          patient.birthday = patient.birthday.replace(/-/g, "/")
        })
      })
      obj.belongsId = this.belongsId
      return client.apis.externalKenshin.setKenshinApplicationPOST({
        body:obj
      });
    },
    setKenshinApplicationPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.requestDate = result.obj.requestDate
      this.receiptNumber = result.obj.receiptNumber
      this.compleateFlg = true;
    },
    setKenshinApplicationPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    patientAddressSearch: function(val,index,target){
      // 検索対象の郵便番号を設定
      this.searchTargetPostCode = val
      this.searchTargetAddress = null
      this.postCodeSearch().then(result=>{
        if (!this.searchTargetAddress) return;
        if(target=="item"){
          this.reqParams.shippingInfoList[index].deviceDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        }else if(target=="result"){
          this.reqParams.shippingInfoList[index].resultDeliveryAddress = this.searchTargetAddress.prefecture + " " + this.searchTargetAddress.city + " " + this.searchTargetAddress.town
        }
        // 再レンダリングの為、フラグ切替
        this.renderKey = !this.renderKey
      })
    },
    postCodeSearch: function(){
      var excuteApi = this.getAddressFromPostCodePOST;
      var successCallBack = this.getAddressFromPostCodePOSTSuccess;
      var errorCallBack = this.getAddressFromPostCodePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getAddressFromPostCodePOST: function(client) {
      return client.apis.apiCommon.getAddressFromPostCodePOST({
        body:{
          postCode:this.searchTargetPostCode
        }
      });
    },
    getAddressFromPostCodePOSTSuccess: function(result) {
      this.searchTargetAddress = result.obj
      this.searchTargetPostCode = ""
    },
    getAddressFromPostCodePOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
      this.searchTargetPostCode = ""
    },
    back: function() {
      this.$router.go(-1);
    },
    goHome: function() {
      this.back();
    },
    deleteItem: function(index) {
      this.reqParams.shippingInfoList.splice(index, 1);
    },
    changeDisabled: function(index) {
      var checkBoxId = "checked" + index;
      var appedTable = "appedTable" + index;
      var isChecked = document.getElementById(checkBoxId).childNodes[0].checked;
      console.log(isChecked)
      if (isChecked) {
        document.getElementById(appedTable).style.display = "block";
      } else {
        document.getElementById(appedTable).style.display = "none";
      }
    },
    addAddress: function() {
      this.reqParams.shippingInfoList.push(
        {
          subjectList: [
            {
              familyName: "",
              firstName: "",
              familyNameKana: "",
              firstNameKana: "",
              birthday: "",
              gender: "-",
              employeeNumber: ""
            }
          ],
          resultDelivery: false,
          resultDeliveryZip: "",
          invalidShippingPostcode: false,
          invalidShippingPhoneNumber: false,
          invalidDeliveryPostcode: false,
          deviceDeliveryZip: "",
          phoneNumber: ""
        }
      );
    },
    addMember: function(index) {
      this.reqParams.shippingInfoList[index].subjectList.push({familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""});
      this.patientCount += 1
    },
    readTsv: function(index) {
      this.patientCount -= this.reqParams.shippingInfoList[index].subjectList.length

      this.reqParams.shippingInfoList[index].subjectList = JSON.parse(JSON.stringify(this.reqParams.shippingInfoList[index].subjectList));
      this.patientCount += this.reqParams.shippingInfoList[index].subjectList.length
    },
    clearMember: function(index) {
      this.patientCount -= this.reqParams.shippingInfoList[index].subjectList.length
      this.reqParams.shippingInfoList[index].subjectList = [{familyName:"", firstName:"", familyNameKana:"", firstNameKana:"",birthday:"",gender:"-",employeeNumber:""}];
    },
    deleteMember: function(index, rowNum){
      this.reqParams.shippingInfoList[index].subjectList.splice(rowNum, 1)
      this.patientCount -= 1
    },
    setOrganization: function(organizationInfo){
      this.reqParams.orderCompanyName = organizationInfo.orgName;
      this.reqParams.institutionId = organizationInfo.id + "";
      this.srcShippingInfo.deviceDeliveryZip = organizationInfo.postcode
      this.srcShippingInfo.deviceDeliveryAddress = organizationInfo.prefecture + " " + organizationInfo.address + " " + organizationInfo.houseNumber + " " + organizationInfo.building
      if(this.reqParams.shippingInfoList.length == 1 && !this.reqParams.shippingInfoList[0].enterpriseName){
        this.reqParams.shippingInfoList[0] = this.srcShippingInfo
      }
      // 検査種類マスタ取得
      this.getChoicesListLinkedEstimate()
    },
    getChoicesListLinkedEstimate: function() {
      var excuteApi = this.getChoicesListLinkedEstimatePOST;
      var successCallBack = this.getChoicesListLinkedEstimatePOSTSuccess;
      var errorCallBack = this.getChoicesListLinkedEstimatePOSTError;
      // WebAPI Call
      return this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getChoicesListLinkedEstimatePOST: function(client){
      let belongId = this.belongsId
      let institutionId = this.reqParams.institutionId? this.reqParams.institutionId: 0

      return client.apis.apiCommon.getChoicesListLinkedEstimatePOST({
        body: {
          belongId: belongId,
          institutionId: institutionId
        }
      });
    },
    getChoicesListLinkedEstimatePOSTSuccess: function(result) {
      //検査種類リストをAPIからの取得値から抽出
      this.inspectionKindListLinkedEstimate = result.obj.filter(data => { return data.choicesType == this.choicesType.kenshinKind });
      if(this.isAccommodations){
        this.inspectionKindListLinkedEstimate =　this.inspectionKindListLinkedEstimate.filter((val) => {return val.label3 == "スクリーニング"})
      }
      this.inspectionKindListLinkedEstimate.unshift({})
      this.setInspectionKindList(this.reqParams.demo)
    },
    getChoicesListLinkedEstimatePOSTError: function(result){
      this.showErrorMessage(result);
    },
    setInspectionKindList: function(isDemo){
      if((!this.isDealer && this.belongsId) || (this.isDealer && this.reqParams.institutionId)){
        if(isDemo){
          // 選択肢マスタの検査種類を設定
          this.inspectionKindList = this.getChoiceList(this.choicesType.kenshinKind, false);
          if(this.isAccommodations){
            this.inspectionKindList =　this.inspectionKindList.filter((val) => {return val.label3 == "スクリーニング"})
          }
          this.inspectionKindList.unshift({})
        } else {
          // 見積りコードが紐づいている検査種類を設定
          this.inspectionKindList = this.inspectionKindListLinkedEstimate
        }
      }
    },
    print: function(){
      window.print();
    },
    getAgreementStr: async function() {
      var excuteApi = this.getConsentStatementPOST;
      var successCallBack = this.getConsentStatementPOSTSuccess;
      var errorCallBack = this.getConsentStatementPOSTError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getConsentStatementPOST: function(client) {
      var type = this.consentStatement.kenshin_corp;
      if(this.isHospital){
        type = this.consentStatement.kenshin_hospital;
      } else if(this.isDealer){
        type = this.consentStatement.kenshin_dealer;
      } else if(this.isAccommodations){
        type = this.consentStatement.kenshin_accommodations;
      }
      return client.apis.apiCommon.getConsentStatementPOST({
         body: {
           type: type
         } 
      });
    },
    getConsentStatementPOSTSuccess: function(result) {
      if(result.body.contents != ""){
        this.agreement = result.body.contents;
        this.canAgree = true;
      } else {
        this.agreement = "利用規約が登録されていません。";
      }

    },
    getConsentStatementPOSTError: function(result) {
      this.agreement == "利用規約を取得できませんでした。";
    },
    setSurrogate: function(organizationInfo) {
      switch(organizationInfo.role){
        case role.role_hospital:
          this.requester = "医療機関（" + organizationInfo.orgName + "）"
          break;
        case role.role_corporation:
          this.requester = "企業（" + organizationInfo.orgName + "）"
          break;
        case role.role_dealer:
          this.requester = "ディーラー（" + organizationInfo.orgName + "）"
          break;
        case role.role_accommodations:
          this.requester = "宿泊施設（" + organizationInfo.orgName + "）"
          break;
        default:
          this.requester = "（" + organizationInfo.orgName + "）"
          break;
      }
      this.isDealer = organizationInfo.role == this.role.role_dealer
      this.isHospital = organizationInfo.role == this.role.role_hospital
      this.isAccommodations =  organizationInfo.role == this.role.role_accommodations
      this.isHospitalAgree = !this.isDealer

      if(this.isAccommodations){
        this.title = "スクリーニング検査申込み"
      }
      var minDate = new Date();
      if(this.isAccommodations){
        this.miniDate = this.getBusinessDay(minDate, 2);  //宿泊施設（スクリーニング検査）はHSTと同じ2営業日。
      }
      if(!this.isDealer){
        this.reqParams.orderCompanyName = organizationInfo.orgName;
        this.srcShippingInfo.deviceDeliveryZip = organizationInfo.zip;
        this.srcShippingInfo.deviceDeliveryAddress = organizationInfo.prefecture + " " + organizationInfo.city + " " + organizationInfo.address + " " + organizationInfo.building;
        this.srcShippingInfo.phoneNumber = organizationInfo.phoneNumber;
        this.srcShippingInfo.deviceDeliveryName =  organizationInfo.orgName;
        this.reqParams.shippingInfoList[0] = this.srcShippingInfo;
      }else{
        this.reqParams.orderCompanyName=""
        this.srcShippingInfo.deviceDeliveryZip = "";
        this.srcShippingInfo.deviceDeliveryAddress = "";
        this.srcShippingInfo.phoneNumber = "";
        this.srcShippingInfo.deviceDeliveryName = "";
        this.reqParams.shippingInfoList[0] = this.srcShippingInfo;
      }
      this.userId = organizationInfo.id
      this.belongsId = organizationInfo.id
      this.reqParams.institutionId = ""
      this.reqParams.note = organizationInfo.note
      this.getChoicesListLinkedEstimate()
    }
  },
  data() {
    var isProxyApplication = this.$route.params["agent"];
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var roleId =  userInfo.roleId;
    var userId = userInfo.belongsId;
    var title = "企業検診申込み";
    if(roleId == role.role_accommodations){
      title = "スクリーニング検査申込み"
    }
    var isDealer = roleId == role.role_dealer
    var isHospital = roleId == role.role_hospital
    var isHonsha = roleId == role.role_headOffice
    var isAdmin = roleId == role.role_admin
    var isSalesOffice = roleId == role.role_salesOffice
    var srcShippingInfo = {
      enterpriseName:"",
      deviceDeliveryZip:"",
      deviceDeliveryAddress:"",
      phoneNumber:"",
      deviceDeliveryName:"",
      resultDelivery:false,
      resultDeliveryZip:"",
      resultDeliveryAddress:"",
      resultDeliveryName:"",
      // 半角数字エラーメッセージ表示
      invalidShippingPostcode: false,
      invalidShippingPhoneNumber: false,
      invalidDeliveryPostcode: false,
      subjectList: [
        {
          familyName: "",
          firstName: "",
          familyNameKana: "",
          firstNameKana: "",
          birthday: "",
          gender: "-",
          employeeNumber: ""
        }
      ]
    };
    if(roleId == role.role_corporation || roleId == role.role_accommodations){
      // 企業 OR 宿泊施設
      srcShippingInfo.deviceDeliveryZip = userInfo.postcode
      srcShippingInfo.deviceDeliveryAddress = userInfo.prefecture + " " + userInfo.city + " " + userInfo.address + " " + userInfo.building
      srcShippingInfo.phoneNumber = userInfo.phoneNumber
    }
    var miniDate = new Date();
    if(roleId != role.role_accommodations){
      miniDate.setDate(miniDate.getDate() + 14);
    } else {
      miniDate = this.getBusinessDay(miniDate, 2);  //宿泊施設（スクリーニング検査）はHSTと同じ2営業日。
    }
    var maxDate = new Date()
    maxDate.setDate(maxDate.getDate() + 365);
    return {
      role: role,
      userId: userId,
      choicesType:choicesType,
      belongsId: !isProxyApplication ? userInfo.belongsId : 0,
      isHospitalAgree: roleId != role.role_dealer,
      isDealer,
      isSalesOffice,
      isHonsha,
      isAdmin,
      isHospital,
      isAccommodations: roleId == role.role_accommodations,
      title: title,
      isChecked: false,
      agreement: "",
      activeStep: 0,
      organizationModalActive: false,
      reqParams:{
        orderCompanyName:isProxyApplication || isDealer || isHospital ? "" : userInfo.medicalInstitutionName + " " + userInfo.departmentName,
        desiredShippingWeek:"",
        inspectionKind:"",
        isJudgment: true,
        biko:"",
        deliverySlip:false,
        demo:false,
        institutionId: "",
        shippingInfoList: [ srcShippingInfo ],
      },
      patientCount:0,
      compleateFlg:false,
      requestDate:"",
      receiptNumber:"",
      searchTargetPostCode:"",
      searchTargetAddress:"",
      renderKey:true,
      tsvfile: null,
      needAgree: roleId == role.role_hospital || roleId == role.role_dealer || roleId == role.role_corporation || roleId == role.role_accommodations,
      canAgree:false,
      consentStatement:consentStatement,
      inspectionKindList:[],
      inspectionKindListLinkedEstimate:[],
      srcShippingInfo,
      miniDate,
      maxDate,
      extUserStatus:extUserStatus,
      isProxyApplication,
      surrogateModalActive:false,
      requester:"",
      note:"",
    }
  },
  components: {
    facilitySelectModal:FacilitySelectModal,
    kenshinRequestDetail: kenshinRequest,
    organizationSelectModal:OrganizationSelectModal
  },
  async mounted() {
    //同意文取得
    await this.getAgreementStr();
    // 検査種類マスタ取得
    await this.getChoicesListLinkedEstimate();
  },
  computed: {
    // 半角数字エラーテンプレートメッセージ
    invalidNumberMessage() {
      return invalidNumberMessage;
    },
    // 郵便番号入力におけるプレースフォルダー
    postcodePlaceholder() {
      return postcodePlaceholder;
    },
    // 電話番号入力におけるプレースフォルダー
    phonePlaceholder() {
      return phonePlaceholder;
    },
  },
  watch: {
    "reqParams.shippingInfoList": {
      handler(newValue) {
        newValue.map((value) => {
          value.invalidShippingPostcode = isNaN(Number(value.deviceDeliveryZip));
          value.invalidShippingPhoneNumber = isNaN(Number(value.phoneNumber));
          value.invalidDeliveryPostcode = isNaN(Number(value.resultDeliveryZip));
        });
      },
      deep: true,
    }
  }
};
</script>

<style>
</style>
<style lang="scss" scoped>
.th_brank {
  width: 20px !important;
}
.th_no {
  width: 10px !important;
  margin-left: 5px;
}
.th_name {
  width: 70px !important;
  margin-left: 5px;
}
.th_birth {
  width: 50px !important;
  margin-left: 5px;
}
.th_gender {
  width: 30px !important;
  margin-left: 5px;
}
.th_id {
  width: 100px !important;
  margin-left: 5px;
}
.th_clear {
  width: 30px !important;
  margin-left: 5px;
}
.clearBtn {
  margin-left: 5px;
  height: 27px !important;
  width: 27px !important;
}
.zip-mark {
  margin-top: 10px;
  margin-left: 20px;
}
.address-area {
  margin-left: 5px;
  width: 729px !important;
}
.memberlist-area {
  margin-top: 10px;
}
.passButton{
  margin-top:10px;
  height:30px;
}
.width30 {
  width:30px !important;
}
.patientListButton {
  width: 110px !important;
  height:30px !important;
  -webkit-appearance: button !important;
}
.NameField{
  width: 98% !important;
  height:28px !important;
}
.invalid-postcode {
  margin-left: 40px;
  margin-top: -8px;
}
.invalid-phone-number {
  margin-top: 4px;
  margin-left: 130px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/guest/KenshinRequest.vue